var lang   = require('./lang')
var extend = lang.extend

extend(exports, lang)
extend(exports, require('./env'))
extend(exports, require('./dom'))
extend(exports, require('./misc'))
extend(exports, require('./debug'))
extend(exports, require('./options'))


/*****************
 ** WEBPACK FOOTER
 ** ../vue/src/util/index.js
 ** module id = 2
 ** module chunks = 0
 **/